module.exports = __webpack_public_path__ + "static/media/background.7d8141b1.png";